import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService, PaymentV2Service, UtilService, VariablesService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-payment-sip-switch-pay-button',
  templateUrl: './payment-sip-switch-pay-button.component.html',
  styleUrls: ['./payment-sip-switch-pay-button.component.scss']
})
export class PaymentSipSwitchPayButtonComponent implements OnInit {

  @Input() config: IPaymentSipConfig;
  @Output() paySwitchEmit = new EventEmitter();
  originaldonateBtnLabel;
  originalAmount;
  originalSet = false;

  switchBtns = [
    {
      button: 'auto_pay',
      topIconClass: 'icon-setup-autopay',
      heading: 'Setup Autopay',
      desc: `Your contribution will be auto-deducted every month starting from ${dayjs(new Date()).format('DD/MM/YYYY')}.`,
      bottomIconClass: ['icon-bank', 'icon-cards', 'icon-wallet']
    },
    {
      button: 'sip_wallet',
      topIconClass: 'icon-wallet',
      heading: 'Add to Wallet',
      desc: `Add Money to your wallet to ensure Monthly contributions for next 6 months.`,
      bottomIconClass: ['icon-bank', 'icon-cards', 'icon-wallet', 'icon-upi']
    }
  ];

  constructor(
    public paymentV2: PaymentV2Service,
    public variablesService: VariablesService,
    private util: UtilService,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.event(this.config.payType);
  }

  switchBtn(payType) {

    if (!this.originalSet) {
      this.originaldonateBtnLabel = this.config.donateBtnLabel;
      this.originalAmount = this.config.amount;
      this.originalSet = true;
    }

    if (this.config.payType !== payType) {
      let data = { payType };
      if (payType === 'sip_wallet') {
        const walletAmt = this.config.frequency_term === 'days' ? (this.originalAmount * (Math.ceil(this.config.wallet_tenure * 30 / (+this.config.frequency || 1)))) : (this.originalAmount * this.config.wallet_tenure);
        data = Object.assign(data, {
          donateBtnLabel: `Add ${this.util.formatAmount(walletAmt, this.config.currency)} to Ketto Wallet`,
          sip_wallet: 1,
          hideRecommendedNote: true,
          showTutorial: false,
          amount: walletAmt
        });
      } else {
        data = Object.assign(data, this.reset());
      }
      this.paymentV2.paymentConfig.next(data);
      this.paySwitchEmit.emit(true);
      this.event(payType);
    }
  }

  reset() {
    return {
      amount: this.originalAmount,
      donateBtnLabel: this.originaldonateBtnLabel,
      sip_wallet: null,
      hideRecommendedNote: false,
      showTutorial: true
    };
  }

  event(payType) {
    const eventName = payType === 'auto_pay' ? 'Autopay_click' : (payType === 'sip_wallet' ? 'Wallet_click' : payType);
    this.eventsService.sendSystemEvent({
      eventName: eventName,
      page_name: this.variablesService.pageName
    }).subscribe(_ => _);
  }

}
